<template>
  <section id="countdown-section" class="module" v-if ="event" v-once>
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-5 col-md-6">
          <h2>{{ event.name }}</h2>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-6">
          <ul id="countdown" ref="countdown">
            <li>
              <span class="days time-font">00</span>
              <p>days </p>
            </li>
            <li>
              <span class="hours time-font">00</span>
              <p class="">hours </p>
            </li>
            <li>
              <span class="minutes time-font">00</span>
              <p class="">minutes</p>
            </li>
            <li>
              <span class="seconds time-font">00</span>
              <p class="">seconds</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="cart" v-if ="event.tickets_url">
        <a :href="event.tickets_url"><i class="fa fa-shopping-cart"></i> <span>Purchase Tickets</span></a>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  mounted () {
    const self = this

    if (!this.event) {
      return
    }

    this.countdownInit()

    $(self.$refs.countdown).countdown({
      date: self.event.start.toString(),
      format: 'on'
    })
  },
  methods: {
    countdownInit () {
      $.fn.countdown = function (options, callback) {
        let eventDate = null
        let currentDate = null
        let seconds = null
        let minutes = null
        let hours = null
        let days = null
        let interval = null

        // custom 'this' selector
        let thisEl = $(this)

        // array of custom settings
        let settings = {
          'date': null,
          'format': null
        }

        // append the settings array to options
        if (options) {
          $.extend(settings, options)
        }

        function countdownProc () {
          eventDate = Date.parse(settings['date']) / 1000
          currentDate = Math.floor($.now() / 1000)

          if (eventDate <= currentDate) {
            callback.call(this)
            clearInterval(interval)
          }

          seconds = eventDate - currentDate

          days = Math.floor(seconds / (60 * 60 * 24)) // calculate the number of days
          seconds -= days * 60 * 60 * 24 // update the seconds variable with no. of days removed

          hours = Math.floor(seconds / (60 * 60))
          seconds -= hours * 60 * 60 // update the seconds variable with no. of hours removed

          minutes = Math.floor(seconds / 60)
          seconds -= minutes * 60 // update the seconds variable with no. of minutes removed

          // conditional Ss

          if (days === 1) {
            thisEl.find('.timeRefDays').text('day')
          } else {
            thisEl.find('.timeRefDays').text('days')
          }

          if (hours === 1) {
            thisEl.find('.timeRefHours').text('hour')
          } else {
            thisEl.find('.timeRefHours').text('hours')
          }
          if (minutes === 1) {
            thisEl.find('.timeRefMinutes').text('minute')
          } else {
            thisEl.find('.timeRefMinutes').text('minutes')
          }
          if (seconds === 1) {
            thisEl.find('.timeRefSeconds').text('second')
          } else {
            thisEl.find('.timeRefSeconds').text('seconds')
          }

          // logic for the two_digits ON setting

          if (settings['format'] === 'on') {
            days = (String(days).length >= 2) ? days : '0' + days
            hours = (String(hours).length >= 2) ? hours : '0' + hours
            minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes
            seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds
          }

          // update the countdown's html values.

          if (!isNaN(eventDate)) {
            thisEl.find('.days').text(days)
            thisEl.find('.hours').text(hours)
            thisEl.find('.minutes').text(minutes)
            thisEl.find('.seconds').text(seconds)
          } else {
            alert('Invalid date. Here\'s an example: 12 Tuesday 2012 17:30:00')
            clearInterval(interval)
          }
        }

        // run the function
        countdownProc()

        // loop the function
        interval = setInterval(countdownProc, 1000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CountDown.vue